'use strict';

var flatten = require('./flatten');
var map = require('./map');

var flatMap = function flatMap(input) {
  for (var _len = arguments.length, fns = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    fns[_key - 1] = arguments[_key];
  }

  return map.apply(undefined, [flatten(input)].concat(fns));
};

module.exports = flatMap;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/flatMap.js
// module id = 2183
// module chunks = 37